import React, { Component } 	from "react"
import { connect } 				from 'react-redux'
import { post } 				from '../../services/apiServices'
import { token } 				from '../../services/authServices'
import { withStyles } 			from 'material-ui/styles'
import { CircularProgress } 	from 'material-ui/Progress'
import ReactPaginate 			from 'react-paginate'
import Icon 					from 'material-ui/Icon'
import Button 					from 'material-ui/Button'
import TextField 				from 'material-ui/TextField'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow } 					from 'material-ui/Table'
import Dialog, {
	DialogContent,
	DialogActions,
	DialogTitle } 				from 'material-ui/Dialog'

const styles = {
	progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    },
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	tableRow: {
		cursor: 'pointer'
	},
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	justifyCenter: {
		justifyContent: 'center'
	}
}

class ClassRooms extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'open' : false,
			'classRooms' : this.props.classRooms,
			'name' : '',
			'errors' : {}
		}
	}

	getClassRooms = () => {
		this.props.initClassRooms(this.props.accountId).then(res => {
			this.setState({'classRooms' : this.props.classRooms})
		})
	}

	onSubmit = () => {
		let name = this.state.name
		post(`/admin/accounts/${this.props.accountId}/classes`, {'name' : name}, token, err => {
			let response = JSON.parse(err._bodyText)

			this.setState({'errors' : response.errors})
		}).then(res => {
			let response = res.data

			if (response.data) {
				this.getClassRooms()
				this.handleToggleModal(false)
			}
		})
	}

	handleInputChange = e => {
  	  let state = this.state
  	  state[e.target.name] = e.target.value

  	  this.setState(state)
    }

	handleToggleModal = bool => {
		if (!bool)
			this.setState({'name' : ''})

		this.setState({'open' : bool})
	}

	handlePageChange = action => {
		this.props.pageChange(this.props.accountId, action.selected + 1).then(res => {
			this.setState({'classRooms' : this.props.classRooms})
		})
	}

	renderClassRoomsList = () => {
		let classRooms = this.state.classRooms.data
		let result = []

		classRooms.map(classRoom => {
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={classRoom.id}
					onClick={() => this.props.toClassRoom(classRoom.id)}>
					<TableCell padding="none">
						{classRoom.name}
					</TableCell>
					<TableCell padding="none">
						{classRoom.players}
					</TableCell>
					<TableCell padding="none">
						{classRoom.updated_at.date}
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	renderPagination = () => {
		let meta = this.state.classRooms.meta
		let last_page = meta.last_page
		let current_page = meta.current_page - 1
		let pagination = null

		last_page > 1 ?
			pagination = <ReactPaginate
				previousLabel={<Icon>navigate_before</Icon>}
				nextLabel={<Icon color="primary">navigate_next</Icon>}
				breakLabel={<a href="">...</a>}
				breakClassName={"break-me"}
				pageCount={last_page}
				initialPage={current_page}
				disableInitialCallback= {true}
				marginPagesDisplayed={2}
				pageRangeDisplayed={5}
				onPageChange={this.handlePageChange}
				containerClassName={"pagination"}
				subContainerClassName={"pages pagination"}
				activeClassName={"active"}
			/>
		: null

		return pagination
	}

	componentWillMount() {
		this.getClassRooms()
	}

	classes = this.props.classes

	render() {
		const {classRooms, name, errors} = this.state
		let isFetching = classRooms ? classRooms.isFetching : true
		let disable = name.length < 3

		return(
			isFetching ?
			<div className={this.classes.progressWrapper}>
				<CircularProgress
					className={this.classes.progress}
					size={50}
				/>
			</div>
			:
			<div>
				<Dialog
					open={this.state.open}
					onClose={() => this.handleToggleModal(false)}>
					<DialogTitle>
						<Icon
							className={this.classes.closeIcon}
							onClick={() => this.handleToggleModal(false)}>
							close
						</Icon>
						Add
					</DialogTitle>
					<DialogContent>
						<TextField
							error={errors.name}
							label="Name"
							name="name"
							value={this.state.name}
							onInput={this.handleInputChange}
							helperText={
								errors.name ? errors.name[0] : false
							}
						/>
					</DialogContent>
					<DialogActions className={this.classes.justifyCenter}>
						<Button
							variant="raised"
							color="primary"
							onClick={this.onSubmit}
							disabled={disable}>
							Add
						</Button>
					</DialogActions>
				</Dialog>
				<div className={this.classes.titleWrap}>
					{
						classRooms.data && classRooms.data.length ?
						<h2 className={this.props.classes.title}>
							Class
						</h2>
						:
						<h2>
							Not found
						</h2>
					}
					<Button
						variant="raised"
						color="primary"
						onClick={() => this.handleToggleModal(true)}>
						Add Class
					</Button>
				</div>
				{
					classRooms.data && classRooms.data.length ?
					<div>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell
										width="40%"
										padding="none">
										NAME
									</TableCell>
									<TableCell
										width="40%"
										padding="none">
										STUDENTS
									</TableCell>
									<TableCell padding="none">
										LAST UPDATE
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{this.renderClassRoomsList()}
							</TableBody>
						</Table>
						{this.renderPagination()}
					</div>
					: null
				}
			</div>
		)
	}
}

export default withStyles(styles)(ClassRooms)



// WEBPACK FOOTER //
// ./src/components/content/ClassRooms.js